import { BoardInvitation } from 'app/scripts/models/BoardInvitation';
import InvitationList from 'app/scripts/models/collections/invitation-list.coffee';

class BoardInvitationList extends InvitationList {
  static initClass() {
    this.prototype.model = BoardInvitation;
  }
}
BoardInvitationList.initClass();

export { BoardInvitationList };
